import '@fontsource-variable/inter';
import '@getflip/swirl-components/dist/swirl-components/swirl-components.css';
import { defineCustomElements, setNonce } from '@getflip/swirl-components/loader';
import '@getflip/swirl-tokens/dist/css/styles.light.custom-properties.css';
import { registerReactControllerComponents } from '@symfony/ux-react';
import './bootstrap';
/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (app.css in this case)

// import js
import './js/app';

// Set nonce if CSP is being used
const nonceMeta = document.querySelector('meta[name="csp-nonce"]');
if (nonceMeta) {
    setNonce(nonceMeta.getAttribute('content'));
}

// Define custom elements and wait for them to be ready
defineCustomElements(window).then(() => {
    // Register React controller components after Swirl components are ready
    registerReactControllerComponents(require.context('./react/controllers', true, /\.(j|t)sx?$/));
});